export default __webpack_public_path__ + "static/media/DBSLogo.488b5495.png";